<h2 mat-dialog-title>Edit Product</h2>
<mat-form-field appearance="fill">
  <mat-label>Product/Service</mat-label>
  <mat-select [(ngModel)]="product.productType" (ngModelChange)="fetchhsnno($event)"
    name="productType">
    <mat-option *ngFor="let item of productOptions" [value]="item.id">{{ item.item_name }}</mat-option>
  </mat-select>
</mat-form-field>
<mat-form-field appearance="fill">
  <mat-label>HSN/SAC</mat-label>
  <input matInput type="text" [(ngModel)]="product.hsn_no" name="hsn_no" disabled>
</mat-form-field>
<mat-form-field appearance="fill">
  <mat-label>Description</mat-label>
  <input matInput type="text" [(ngModel)]="product.description" name="description">
</mat-form-field>
<mat-form-field appearance="fill">
  <mat-label>UoM</mat-label>
  <input matInput type="text" [(ngModel)]="product.unit" name="unit" disabled>
</mat-form-field>
<mat-form-field appearance="fill">
  <mat-label>QTY</mat-label>
  <input matInput type="number" [(ngModel)]="product.qty" name="qty">
</mat-form-field>
<mat-form-field appearance="fill">
  <mat-label>Unit Price</mat-label>
  <input matInput type="number" [(ngModel)]="product.unitPrice" name="unitPrice">
</mat-form-field>
<mat-form-field appearance="fill">
  <mat-label>Discount(%)</mat-label>
  <input matInput type="number" [(ngModel)]="product.discount" name="discount">
</mat-form-field>
<mat-form-field appearance="fill">
  <mat-label>Tax</mat-label>
  <mat-select [(ngModel)]="product.taxType" name="taxType">
    <mat-option *ngFor="let item of taxOptions" [value]="item.id">{{ item.gst_percentage }}%</mat-option>
  </mat-select>
</mat-form-field>
<button mat-button class="btn btn-success" (click)="onSave()">Update</button>
<button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>